import { create } from 'zustand/react';

type AuthStore = {
  activeToken: string | null;
  setActiveToken: (token: string | null) => void;
};

export const useAuthStore = create<AuthStore>((set) => ({
  activeToken: null,
  setActiveToken: (token) => set({ activeToken: token }),
}));
